import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, CheckTreePicker, CheckTreePickerProps } from "rsuite";
import { PickerHandle } from "rsuite/esm/internals/Picker/types";
import { ValueType } from "rsuite/CheckTreePicker";

import "./SubmittableCheckTreePicker.less";

interface SubmittableCheckTreePickerProps extends Omit<
    CheckTreePickerProps,
    "ref" | "renderExtraFooter"
> {
    onChange?: (value: ValueType) => void;
}

const SubmittableCheckTreePicker: React.FC<SubmittableCheckTreePickerProps> = (
    props: SubmittableCheckTreePickerProps
) => {
    const { t } = useTranslation();
    const ref = useRef<PickerHandle>(null);

    const [values, setValues] = useState<string[]>(props.value as string[]);
    const [submit, setSubmit] = useState<boolean | null>(null);

    const handleClean = (event: React.SyntheticEvent) => {
        setValues([]);
        setSubmit(true);

        props.onClean?.(event);
    };

    const handleChange = (value: ValueType) => setValues(value as string[]);
    const handleClose = () => setSubmit(false);
    const handleSubmit = () => setSubmit(true);

    useEffect(() => {
        if (submit) {
            props.onChange?.(values);
            ref.current?.close?.();
        } else {
            setValues(props.value as string[]);
        }

        setSubmit(null);
    }, [submit]);

    const footer = (
        <div className={"submittable-check-tree__footer"}>
            <Button size={"sm"} appearance="primary" onClick={handleSubmit}>
                {t("tenantConfig.okButton")}
            </Button>
        </div>
    );

    return (
        <CheckTreePicker
            {...props}
            ref={ref}
            value={values}
            onChange={handleChange}
            onClean={handleClean}
            onClose={handleClose}
            renderExtraFooter={() => footer}
        />
    );
};

export default SubmittableCheckTreePicker;
